import React, { useEffect } from 'react';
import { Radio, RadioGroup, FormControl, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const EffectiveInsuranceType = ({ options, isModEdit }: { options: any; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue, setError } = useFormContext();
  const dispatch = useDispatch();
  const effectiveDateTypeId = 'effectiveDateTypeId';
  const effectiveDateType: any = useWatch({ name: effectiveDateTypeId });

  useEffect(() => {
    setValue('effectiveDateTypeId', effectiveDateType);
    dispatch(placementModsAction.setInsuranceEffectiveType(effectiveDateType));
    if (!effectiveDateType) {
      setError('effectiveDateTypeId', {});
    }
  }, []);

  return (
    <FormControl>
      <Typography component="span" style={{ color: 'theme.palette.system.darkGray' }}>{`${t(
        'placement.placementMods.effectiveType',
      )}`}</Typography>
      <Controller
        control={control}
        name={effectiveDateTypeId}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value, ...rest } }) => {
          return (
            <FormControl disabled={!isModEdit}>
              <RadioGroup
                row
                value={getValues(effectiveDateTypeId)}
                name={'effectiveDateTypeId'}
                onChange={e => {
                  setValue('effectiveDateTypeId', e.target.value);
                  dispatch(placementModsAction.setInsuranceEffectiveType(e.target.value));
                  onChange(e);
                }}
              >
                {options &&
                  options.map(option => (
                    <FormControlLabel
                      sx={{ mr: '30px' }}
                      checked={parseInt(getValues(effectiveDateTypeId)) === parseInt(option.ID)}
                      key={option.ID}
                      value={option.ID}
                      control={<Radio disableFocusRipple disableRipple disableTouchRipple />}
                      label={option.Description}
                    />
                  ))}
              </RadioGroup>
            </FormControl>
          );
        }}
      />
    </FormControl>
  );
};
